import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { loadRazorpay } from "../utils/RazorpayUtils";
import { useNavigate } from "react-router-dom";
import "./BuyNow.scss";
import HeroImg from "../Components/Layouts/HeroImg";
import {toast} from "react-toastify";
import { useCart } from "../context/CartContext";
import axios from "axios";


const BuyNowPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const cart = location.state?.cart || [];
  const { setCart } = useCart();

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    street: "",
    city: "",
    state: "",
    zipCode: "",
    country: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleBuyNow = async (cart, shippingAddress) => {
    if (cart.length === 0) {
      toast.warning("Your cart is empty!");
      return;
    }
    try {
      setLoading(true);
      const orderItems = cart.map((item) => ({
        medicine: item.medicine._id,
        quantity: item.quantity,
        prescriptionDetail: item.prescriptionDetail,
      }));
      const phoneRegex = /^[0-9]{10}$/;
      if (
        !shippingAddress.name ||
        !shippingAddress.phone ||
        !shippingAddress.street ||
        !shippingAddress.city ||
        !shippingAddress.state ||
        !shippingAddress.zipCode ||
        !shippingAddress.country
      ) {
       toast.warning("Please enter all fields.");
        setLoading(false);
        return;
      }
      else if (!phoneRegex.test(shippingAddress.phone)) {
        toast.warning("Please enter a valid phone number.");
        setLoading(false);
        return;
      }
      else if (shippingAddress.zipCode.length < 6) {
        toast.warning("Please enter a valid zip code.");
        setLoading(false);
        return;
      }

      // Step 1: Create Order in Backend
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/orders`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            shippingAddress,
            items: orderItems,
          }),
        }
      );
      const orderData = await response.json();
      if (!orderData.razorpayOrder) {
       toast.error("Failed to create order. Please try again.");
        setLoading(false);
        return;
      }else{
        setCart([]);
      }

      const showToast = (msg, opts) => toast(msg, opts);

      // Step 2: Start Payment
      await loadRazorpay(orderData.razorpayOrder, orderData.order, navigate, {
        setLoading,
        showToast
      });
      
      setLoading(false);
    } catch (error) {
      console.error("Error during checkout:", error);
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await handleBuyNow(cart, formData);
  };

  const handlePincodeChange = async (e) => {
    const pin = e.target.value;
    setFormData({ ...formData, zipCode: pin });

    if (pin.length === 6) {
      try {
        const res = await axios.get(`https://api.postalpincode.in/pincode/${pin}`);
        const data = res.data[0];

        if (data.Status === "Success") {
          const postOffice = data.PostOffice[0];
          setFormData({
            ...formData,
            zipCode: pin,
            city: postOffice.Block || "",
            state: postOffice.State || "",
            country: postOffice.Country || "",
          });
        } else {
          toast.warning("Invalid Pincode");
        }
      } catch (error) {
        console.error("Error fetching pincode details:", error);
      }
    }
  };

  return (
    <>
    <HeroImg heading="Buy Now" text="Complete your order" />
      {loading ? (
        <div className="loading-screen">
          <div className="loader"></div>
          <h2>Processing your order....</h2>
          <p>Please wait while we redirect you to the payment page.</p>
        </div>
      ) : (
        <div className="buy-now-page">
          <div className="buy-now-container">
            <h2>Enter Shipping Address</h2>
            <form className="shipping-form"  onSubmit={handleSubmit}>
            <input
                type="text"
                name="zipCode"
                placeholder="Zip Code"
                value={formData.zipCode}
                onChange={handlePincodeChange}
                required
              />
              <br />
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <br />
              <input type="text" name="phone" placeholder="Phone" value={formData.phone} onChange={handleChange} required />
              <br />
              <input
                type="text"
                name="street"
                placeholder="Street"
                value={formData.street}
                onChange={handleChange}
                required
              />
              <br />
              <input
                type="text"
                name="city"
                placeholder="City"
                value={formData.city}
                onChange={handleChange}
                required
              />
              <br />
              <input
                type="text"
                name="state"
                placeholder="State"
                value={formData.state}
                onChange={handleChange}
                required
              />
              <br />
              <input
                type="text"
                name="country"
                placeholder="Country"
                value={formData.country}
                onChange={handleChange}
                required
              />
              <br />

              <button type="submit"  className="paynow"  disabled={loading}>
                Pay Now
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default BuyNowPage;
